import { OrganizationType } from '@cast/types';

import {
  useViewedOrganization,
  buildEnterpriseUrl,
  buildManagementUrl,
} from '@cast/infrastructure-organization';
import { Navigate } from 'components/router';
import { useAbility } from '@cast/shared-ability-data-access';

export const OrganizationSettingsRedirect = () => {
  const viewedOrganization = useViewedOrganization();
  const ability = useAbility();

  // Loading state - wait for organization data
  if (!viewedOrganization) {
    return null;
  }

  const canViewEnterprise = ability.can('view', 'EnterpriseManagement');

  // Enterprise organization - redirect to enterprise overview if user has permission
  if (
    viewedOrganization.type === OrganizationType.ENTERPRISE &&
    canViewEnterprise
  ) {
    return (
      <Navigate to={buildEnterpriseUrl(viewedOrganization.id, 'overview')} />
    );
  }

  // Child organization - redirect to child dashboard
  if (
    viewedOrganization.type === OrganizationType.CHILD &&
    viewedOrganization.parentId
  ) {
    return (
      <Navigate
        to={buildEnterpriseUrl(
          viewedOrganization.parentId,
          'dashboard',
          viewedOrganization.id
        )}
      />
    );
  }

  // Default/standalone organization or no enterprise permission - redirect to management dashboard
  return <Navigate to={buildManagementUrl('dashboard')} />;
};
